import { Injectable } from "@angular/core";

import Talk from "talkjs";
import { Deferred } from "./deffred.util";
import { OnboardingService } from "./onboarding.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class TalkService {
  private currentTalkUser: Talk.User;
  private loadedPopups: Talk.Popup[];
  private currentSessionDeferred = new Deferred<Talk.Session>();

  constructor(private onboardingService: OnboardingService) {
    this.loadedPopups = [];
  }

  async createCurrentSession() {
    await Talk.ready;

    const currentUser = {
      id: this.onboardingService.userProfileDetails.id,
      username: this.onboardingService.userProfileDetails.firstName + this.onboardingService.userProfileDetails.lastName,
      email: this.onboardingService.userProfileDetails.emailAddress,
      photoUrl: this.onboardingService.userProfileDetails.profilePic
    };
    const currentTalkUser = await this.createTalkUser(currentUser);

    const session = new Talk.Session({
      appId: environment.TALKS_APP_ID,
      me: currentTalkUser
    });
    this.currentTalkUser = currentTalkUser;
    return session;
    //this.currentSessionDeferred.resolve(session);
  }

  async createTalkUser(applicationUser: any): Promise<Talk.User> {
    await Talk.ready;

    return new Talk.User({
      id: applicationUser.id,
      name: applicationUser.username,
      photoUrl: applicationUser.photoUrl,
      configuration: "demo_default"
    });
  }

  async createPopup(otherApplicationUser: any, session: Talk.Session): Promise<Talk.Popup> {
    const conversation = await this.getOrCreateConversation(session, otherApplicationUser);
    return session.createPopup(conversation, { keepOpen: true });
  }

  async createChatbox(otherApplicationUser: any): Promise<Talk.Chatbox> {
    const session = await this.currentSessionDeferred.promise;
    const conversationBuilder = await this.getOrCreateConversation(session, otherApplicationUser);

    return session.createChatbox(conversationBuilder);
  }

  async createInbox(session: Talk.Session) {
    const otherApplicationUser = {
      id: this.onboardingService.userProfileDetails.id,
      username: this.onboardingService.userProfileDetails.firstName + this.onboardingService.userProfileDetails.lastName,
      email: this.onboardingService.userProfileDetails.emailAddress,
      photoUrl: this.onboardingService.userProfileDetails.profilePic
    };
    const conversationBuilder = await this.getOrCreateConversation(
      session,
      otherApplicationUser
    );
    return session.createInbox({ selected: conversationBuilder });
  }

  destroyAllLoadedPopups() {
    if (this.loadedPopups.length > 0) {
      this.loadedPopups.forEach(p => p.destroy());
      this.loadedPopups = [];
    }
  }

  private async getOrCreateConversation(session: Talk.Session, otherApplicationUser: any) {
    const otherTalkUser = await this.createTalkUser(otherApplicationUser);

    const conversationBuilder = session.getOrCreateConversation(Talk.oneOnOneId(this.currentTalkUser, otherTalkUser));
    conversationBuilder.setParticipant(this.currentTalkUser);
    conversationBuilder.setParticipant(otherTalkUser);

    return conversationBuilder;
  }
}